<h5>{{ data.titre }}</h5>
<div class="col-md-12">
  Montant HT enveloppe restant actuel : {{data.lineBCEnv.get('htRestant').value}} <br>
  Montant HT enveloppe restant nouveau : {{(data.lineBCEnv.get('htRestant').value - bcLineForm.get('ht').value).toFixed(2)}} <br>
  <mat-divider></mat-divider>
</div>
<div *ngIf="bcLineForm">
  <form focusInvalidInput class="row" [formGroup]="bcLineForm" (ngSubmit)="submit()"
    style="display: flex; justify-content: space-between;">
    <h6>Article</h6>
    <div class="col-md-12 data-class">
      <div class="d-flex" id="row-articles">
        <mat-form-field>
          <mat-label>Désignation</mat-label>
          <input matInput name="nth-ref-Désignation" placeholder="Désignation" formControlName="libelle">
          <mat-error>
            Veuillez saisir une désignation
          </mat-error>
        </mat-form-field>

      </div>
      <div class="d-flex" id="row-articles">
        <mat-form-field class="" id="HT">
          <mat-label>Montant HT</mat-label>
          <input matInput type="number" placeholder="HT" formControlName="ht" lang="fr" step="0.01">
          <mat-icon matSuffix style="color: gray !important; font-size: 14px !important;">euro_symbol
          </mat-icon>
          <mat-error>
            Veuillez saisir un montant positif et supérieur à 0,001
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <h6>Élements financiers</h6>
    <div class="col-md-12 data-class" id="row-ef">

      <div class="subrow-ef">
        <app-autocomplete-with-code-libelle-form class="" [parent]="bcLineForm" libelle="CA2" codeControlName="codeCa2"
          libelleControlName="libelleCa2" placeholder="CA2" [objets]="this.referentiel.ca2s">
        </app-autocomplete-with-code-libelle-form>

        <app-autocomplete-with-code-libelle-form class="" [parent]="bcLineForm" libelle="Complément"
          codeControlName="codeComp" libelleControlName="libelleComp" placeholder="Complément"
          [objets]="this.referentiel.comps">
        </app-autocomplete-with-code-libelle-form>

        <mat-form-field>
          <mat-label>Date livraison</mat-label>
          <input matInput [matDatepicker]="pickerDLivr" name="nth-date-bc-l" [min]="minDateLiv"
            formControlName="dLivraison">
          <mat-datepicker-toggle matSuffix [for]="pickerDLivr"></mat-datepicker-toggle>
          <mat-datepicker #pickerDLivr></mat-datepicker>
          <mat-error *ngIf="bcLineForm.get('dLivraison').hasError('matDatepickerMin')">
            Veuillez sélectionner une date égale ou supérieur à la date du jour
          </mat-error>
        </mat-form-field>
      </div>
    </div>


    <div id="row-autres">
      <h6>Autres</h6>
      <div class="d-flex">
        <div class="d-flex data-class">
          <mat-form-field matTooltip="Numéro de BC / chantier JASON limité à 13 caractères">
            <mat-label>Chantier</mat-label>
            <input matInput name="nth-ref-libelle" placeholder="Chantier" formControlName="chantier">
            <mat-error *ngIf="bcLineForm.get('chantier').hasError('maxlength')">
              Nombre maximum de caractère dépassé.
            </mat-error>
            <mat-error *ngIf="bcLineForm.get('chantier').hasError('pattern')">
              Le format est incorrect (exemple : 12117709.1)
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Équipement</mat-label>
            <input matInput name="nth-ref-libelle" maxlength="12" placeholder="Equipement  " formControlName="vehicule">
          </mat-form-field>
        </div>
        <div>
          <button mat-raised-button color="default" type="button" (click)="cancel()">Annuler</button>
        </div>
        <div>
          <button mat-raised-button color="primary" type="submit">Confirmer</button>
        </div>
      </div>

    </div>
  </form>
</div>
